import { Constants } from '../../constants/constants';
import { Component, OnInit, ViewChild, Input } from '@angular/core';

import { EstructuraControlService } from '../../servicios/estructura-control.service';
import { SetFormService } from '../../servicios/set-form.service';
import { FormTextbox } from '../../model-form/form-textbox';
import { FormDropdown } from '../../model-form/form-dropdown';
import { EstructuraBase } from '../../model-form/estructura-base';
import { Utils } from '../../utils/utils';
import { HelperService } from '../../servicios/helper.service';
import { PersonaService } from '../../servicios/persona.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { DialogAgenciasComponent } from '../../dialogs/dialog-agencias/dialog-agencias.component';

import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';
import { UsuarioService } from 'src/app/servicios/usuario.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-crear-usuario',
  templateUrl: './crear-usuario.component.html',
  styleUrls: ['./crear-usuario.component.css']
})
export class CrearUsuarioComponent implements OnInit {
  @ViewChild('resetForm', {static: false}) resetForm: DynamicFormComponent;
  @Input() dataPersonaActualiza: any;
  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 26; //no se debe repetir
  origenParent = 'creacionusuario'; //no se debe repetir
  parametrosDestino: any[] = [];
  procedimientoDestino: string = '';

  constructor(
    private servicioFormulario: SetFormService,
    public ruta: Utils,
    private formatFormulario: Utils,
    private _helper: HelperService,
    private dialog: MatDialog,
    private servicioPersona: PersonaService,
    private servicioUsuario: UsuarioService,
    private snackBar: MatSnackBar,
  ) {
    this.descripcion = 'Creación De Usuario';
    this.crearFormulario();
  }

  crearFormulario() {
    let response: any;

    this.servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
      this.procedimientoDestino = data[0].procedimientoDestino;
      response = this.formatFormulario.formatFormulario(data);
      this.items = response.arrayDatos;
      this.parametrosDestino = response.parametros;

      return this.items.sort((a, b) => a.order - b.order);
    });
  }

  ngOnInit() { }

  ngOnChanges() {
    //alert('cambio valor' + this.dataPersonaActualiza);
    if (this.dataPersonaActualiza > 0) {
      this.crearFormulario();
    }
  }

  dataFormulario($event) {
    const dataForm = $event;
    if (dataForm.parent === this.origenParent) {
      const respuesta = this.validators(dataForm.datos);
    }
  }

  validators(dataForm) {
    const dialogRef = this.dialog.open(DialogAgenciasComponent, {
      data: '0',
      width: '100em',
      //disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      /*if (result) {
        this.refrescaBusqueda();
      }*/
     // console.log(JSON.stringify(dataForm));
      //console.log('Resultado es :' + result);
      if (typeof result !== "undefined") {
        const infoUsuario = JSON.parse(sessionStorage.getItem('infoUsuario'));  
        let agenciasLista ='';
        result.forEach(element => {
          agenciasLista=agenciasLista+element+',';
        });   
        agenciasLista=agenciasLista.slice(0, -1);
        //console.log(agenciasLista);   
        //return;
        const param = {
          idPersona: dataForm.infoPayload[0].value,
          idTipoUsuario: dataForm.infoPayload[1].value,
          usuario: dataForm.infoPayload[2].value,
          clave: dataForm.infoPayload[3].value,
          descripcion: dataForm.infoPayload[4].value,
          agencias: agenciasLista,
          idUsuario: infoUsuario[0].IdUsuario
        };
        this.servicioUsuario.postUsuario(param)
        .subscribe(result=>{
          this.snackBar.open('Usuario Creado', 'Crear Usuario', {
            duration: 2000
          });
          this.reset();
        });
      }
    });
    //console.log(dataForm);
    /*return;
    this.servicioFormulario.postFormulario(dataForm).subscribe(data => {
      Swal.fire({
        title: this.descripcion,
        text: 'Informacion Almacenada Correctamente.',
        type: 'success'
      });
      this.reset();
    });
    return true;*/
  }

  reset() {
    this.resetForm.resetForm();
  }
}
